import RuleCard, { RuleCardRule } from './RuleCard'

type StageColumnProps = {
  title: string
  dotColorClass: string
  rules: RuleCardRule[]
  onRuleClick?: (rule: RuleCardRule) => void
}

const StageColumn = ({
  title,
  dotColorClass,
  rules,
  onRuleClick,
}: StageColumnProps) => {
  return (
    <div className="flex h-full flex-col rounded-xl border border-doubleNickel-gray-200 bg-doubleNickel-gray-50 p-2.5">
      <div className="flex items-center gap-2.5 px-1.5 pb-3 pt-1">
        <span
          className={`h-2.5 w-2.5 shrink-0 rounded-full ${dotColorClass}`}
          aria-hidden
        />
        <span className="flex-1 truncate text-[13px] font-medium uppercase tracking-[0.06em] text-doubleNickel-gray-700">
          {title}
        </span>
        <span className="rounded-full border border-doubleNickel-gray-200 bg-white px-[7px] py-px text-[11px] font-medium text-doubleNickel-gray-500">
          {rules.length}
        </span>
      </div>

      {rules.length > 0 ? (
        <div className="mt-2 flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto pr-1">
          {rules.map((rule) => (
            <RuleCard
              key={rule.automatedRuleId}
              rule={rule}
              onClick={onRuleClick}
            />
          ))}
        </div>
      ) : (
        <div className="mt-2 flex flex-1 items-center justify-center rounded-md border border-dashed border-doubleNickel-gray-200 px-2 py-6 text-center text-[11px] font-medium text-doubleNickel-gray-400">
          No rules yet
        </div>
      )}
    </div>
  )
}

export default StageColumn
